<template>
  <h2>Member History</h2>
</template>

<script>
export default {}
</script>
